<template>
    <div class="market">
        <h5 class="name">Connect new {{market.name}} account</h5>
        <b-form @submit.prevent="$emit('connectAccount', {name: market.name, value})" class="mb-4">
            <div class="d-flex align-items-end">
                <b-form-group v-if="market.name === 'shopify'"
                              label="Shop name"
                              label-for="shopify-shop-name"
                              class="mr-5">
                    <b-form-input type="text"
                                  id="shopify-shop-name"
                                  v-model="value"
                                  required/>
                </b-form-group>

                <b-form-group v-if="market.name === 'amazon' || market.name === 'ebay'"
                              label="Please select your marketplace region:"
                              :label-for="`${market.name}-code`"
                              class="mr-5">
                    <b-form-select :id="`${market.name}-code`"
                                   v-model="value"
                                   required>
                        <optgroup v-for="(group, name) in codes"
                                  :label="name"
                                  :key="name">
                            <option v-for="(option, i) in group"
                                    :key="i + option.text"
                                    :value="option.value">{{option.text}}</option>
                        </optgroup>
                    </b-form-select>
                </b-form-group>
                <b-btn variant="primary-user" class="mb-3" type="submit">Start integration</b-btn>
            </div>
            <small tabindex="-1" class="form-text text-muted" v-if="market.name === 'amazon'">
                <p>
                    1) Press <b>Start integration</b> and get you <b>Merchant/Seller ID &amp; MWS Auth Token</b>,
                    by giving us access on <b>Authorize a Developer</b> page. <br>
                    2) Click Next on the page. On the next page, accept the License Agreement,
                    and Next again <br>
                    3) Copy your <b>Merchant/Seller ID &amp; MWS Auth Token</b> into the form and press
                    <b>Connect</b>
                </p>
            </small>
        </b-form>
        <b-form v-if="market.name === 'amazon'"
                class="d-flex align-items-center"
                @submit.prevent="connectAccount">
            <b-form-group label="Put Merchant/Seller ID"
                          label-for="amazon-seller-id"
                          class="mr-5">
                <b-form-input type="text"
                              id="amazon-seller-id"
                              v-model="amazonData.mwsSellerId"
                              required/>
            </b-form-group>
            <b-form-group label="Put MWS Auth Token"
                          label-for="amazon-token">
                <b-form-input type="text"
                              id="amazon-token"
                              v-model="amazonData.mwsAuthToken"
                              required/>
            </b-form-group>
            <b-btn variant="success"
                   class="mt-3 ml-5"
                   :disabled="!value"
                   type="submit">Connect
            </b-btn>
        </b-form>
        <template v-if="market.data.length > 0">
            <h5 class="name">{{market.name}} accounts:</h5>
            <b-list-group class="mb-4">
                <b-list-group-item v-for="(account, index) in market.data"
                                   :key="index + 'account'"
                                   variant="success"
                                   class="d-flex align-items-center">
                    <div>
                        <h6>You have connected with this account:</h6>
                        <a :href="account.region ? `https://${getCode(account.region)}` : `https://www.${market.name}.com`">
                            {{account.region ? getCode(account.region) : `www.${market.name}.com`}}
                        </a> -
                        <span v-if="account.shopName">Shop: <b>{{account.shopName}}</b></span>
                        <span v-if="account.username">Username: <b>{{account.username}}</b></span>
                        <span v-if="account.sellerId" >Seller ID: <b>{{account.sellerId}}</b></span>
                    </div>
                    <b-btn variant="danger"
                           class="ml-auto"
                           @click="$root.$emit('bv::show::modal', `confirm-modal-${account.id}`)">
                        Remove integration
                    </b-btn>
                    <confirm-modal :id="account.id" @confirm="$emit('removeIntegration', account.id)"/>
                </b-list-group-item>
            </b-list-group>
        </template>
    </div>
</template>

<script>
    import ConfirmModal from '~cp/UserPanel/Modals/ConfirmModal'

    export default {
        name: 'Market',
        components: {
            ConfirmModal
        },
        props: {
            market: {
                type: Object,
                required: true
            },
            codes: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                value: null,
                amazonData: {
                    mwsAuthToken: '',
                    mwsSellerId: ''
                },
            }
        },
        methods: {
            getCode(value) {
                // TODO: need refactoring
                let regionArr = Object.keys(this.codes)
                let text = ''
                regionArr.forEach(region => {
                    this.codes[region].forEach(code => {
                        if (code.value === value.toString()) {
                            text = code.text
                        }
                    })
                })
                return text
            },
            connectAccount() {
                const formData = {
                    name: this.market.name,
                    amazon: {
                        code: this.value,
                        mwsAuthToken: this.amazonData.mwsAuthToken,
                        mwsSellerId: this.amazonData.mwsSellerId
                    }
                }
                this.$emit('connectAccount', formData)
                Object.assign(this.$data, {
                    value: this.$options.data().value,
                    amazonData: this.$options.data().amazonData
                })
            }
        }
    }
</script>

<style lang="scss">
    .market {
        padding: 30px;

        .name {
            font-weight: bold;
            text-transform: capitalize;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/UserSettings/Marketplaces/Market.vue